/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chip_medium'
export default icon
